/**
 * Contornos 2D amostrados, para peças extrudadas e torneadas.
 *
 * Puro e sem three: os contornos das ferramentas são testados como polígonos
 * (quem fica dentro de quem, quem cruza o eixo) sem WebGL.
 */

export type Ponto2 = readonly [number, number]

/** Arco em torno de `centro`, de `de` a `ate` radianos, sem o ponto inicial. */
export function arco(centro: Ponto2, raio: number, de: number, ate: number, passos: number): Ponto2[] {
  const pontos: Ponto2[] = []
  for (let i = 1; i <= passos; i++) {
    const a = de + ((ate - de) * i) / passos
    pontos.push([centro[0] + raio * Math.cos(a), centro[1] + raio * Math.sin(a)])
  }
  return pontos
}

/** Bézier quadrática amostrada, sem o ponto inicial. */
export function curva(de: Ponto2, controle: Ponto2, ate: Ponto2, passos: number): Ponto2[] {
  const pontos: Ponto2[] = []
  for (let i = 1; i <= passos; i++) {
    const t = i / passos
    const u = 1 - t
    pontos.push([
      u * u * de[0] + 2 * u * t * controle[0] + t * t * ate[0],
      u * u * de[1] + 2 * u * t * controle[1] + t * t * ate[1],
    ])
  }
  return pontos
}

/** Gira `ponto` em torno de `centro` por `angulo` radianos. */
export function girar([x, y]: Ponto2, angulo: number, centro: Ponto2 = [0, 0]): Ponto2 {
  const c = Math.cos(angulo)
  const s = Math.sin(angulo)
  const dx = x - centro[0]
  const dy = y - centro[1]
  return [centro[0] + dx * c - dy * s, centro[1] + dx * s + dy * c]
}

/** Ponto dentro de polígono (regra par-ímpar). */
export function dentroDoPoligono([x, y]: Ponto2, poligono: readonly Ponto2[]): boolean {
  let resultado = false
  for (let i = 0, j = poligono.length - 1; i < poligono.length; j = i++) {
    const [xi, yi] = poligono[i]
    const [xj, yj] = poligono[j]
    if (yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi) resultado = !resultado
  }
  return resultado
}
